import { fetcher, HostEndpoints } from "@olagg/api-hooks";
import { Host } from "@olagg/db-types";

const useHosts = () => {

    const getHosts = async (params: { limit: number; page: number; name?: string }) =>
        fetcher(HostEndpoints.all(params))
            .then(response => ({
                hosts: response.hosts,
                count: response.meta.count
            }));

    const getHost = async (id: string) => fetcher(HostEndpoints.find(id))

    const deleteHost = async (id: string) => fetcher(HostEndpoints.delete(id));

    const createHost = async (data: Partial<Host>) => fetcher(HostEndpoints.create({ host: data }));

    const updateHost = async (id: string, data: Partial<Host>) => fetcher(HostEndpoints.update(id, { host: data }));

    return {
        getHosts,
        getHost,
        deleteHost,
        createHost,
        updateHost
    }
};

export default useHosts;